export function parsePrefixNumberFromElectronicInvoice(electronicInvoice) {
  if (electronicInvoice == null) return null;

  if (typeof electronicInvoice === "object" && !Array.isArray(electronicInvoice)) {
    const prefix =
      electronicInvoice.prefix ??
      electronicInvoice.prefijo ??
      electronicInvoice.Prefijo ??
      electronicInvoice.prefijo_encabezado;
    const number =
      electronicInvoice.number ??
      electronicInvoice.numeroFactura ??
      electronicInvoice.NumeroDocumento ??
      electronicInvoice.invoiceNumber ??
      electronicInvoice.folio_encabezado;
    if (prefix != null && number != null && String(prefix).trim() && String(number).trim()) {
      return { prefix: String(prefix).trim(), number: String(number).trim() };
    }
    return null;
  }

  const str = String(electronicInvoice).trim();
  if (!str) return null;

  try {
    const o = JSON.parse(str);
    if (o && typeof o === "object") {
      return parsePrefixNumberFromElectronicInvoice(o);
    }
  } catch {
    /* seguir con texto plano */
  }

  const embedded = str.match(/\b([A-Z][A-Z0-9]{0,19})-(\d{1,20})\b/i);
  if (embedded) {
    return { prefix: embedded[1], number: embedded[2] };
  }
  const exact = str.match(/^([A-Z0-9]{1,20})-(\d{1,20})$/i);
  if (exact) {
    return { prefix: exact[1], number: exact[2] };
  }
  return null;
}
